"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLink = void 0;
const client_1 = require("@apollo/client");
const error_1 = require("@apollo/client/link/error");
const yanzi_link_1 = require("./yanzi-link");
function createLink(socket, errorHandler) {
    return client_1.ApolloLink.from([error_1.onError(errorHandler), yanzi_link_1.createYanziLink(socket)]);
}
exports.createLink = createLink;
//# sourceMappingURL=createLink.js.map